<template lang="pug">
    .container
        .header Lotto Test
        .select
            select(v-model="name",@change="selectSet(name)")
                option(v-for="name in tests") {{name}}
        .draw(v-if="test && test.draw")
            .date {{test.draw.date}} 
            .numbers
                .number(v-for="n in test.draw.drawNumbersCollection") {{n}}
            div(style="border-left:1px solid gray; margin:0 1vw;")
            .number.sz {{test.draw.superNumber}}
        .draw(v-if="total && test && test.tickets") Gesamtgewinn brutto {{total.toFixed(2)}} €, netto {{(total-18.65*test.tickets.length).toFixed(2)}} €
        div(style="overflow:auto;display:flex;flex-flow:column;align-items:center;")
            div(v-for="(t,ix) in test.tickets",style="display:flex; flex-flow: row wrap; justify-content:space-evenly;align-self:stretch;")
                .ticket 
                    div Ticket {{ix+1}} (SZ {{t.number}})
                    icon.small(name="chevronDown",v-if="current != t",@click="open(t)")
                    icon.small(name="chevronUp",v-if="current == t",@click="close()")
                div(v-if="current == t",v-for="f in t.fields")
                    lotto-grid(:checked="f", :sz="t.number", :id="f.index" :draw="test.draw" :cfg="{ small:1, grid: 1 }")
                .wins(v-if="current == t")
                    tr(v-for="w in test.wins",v-if="w.ticketNum == ix+1")
                        td.tn {{w.ticketNum}} / {{w.index+1}}
                        td.cn {{w.winningClassShortName}}
                        td.odds {{w.odds.toFixed(2)}} €
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Icon from "@/components/Icon.vue";
import Button3d from "@/components/Button3d.vue";
import LottoGrid from "@/components/LottoGrid.vue";
import Labeled from "@/components/Labeled.vue";
export default {
  components: { Icon, Button3d, LottoGrid, Labeled },
  data() {
    return {
        name: '',
        current: null
    }
  },
  computed: {
    ...mapGetters({
      tests: "lotto/tests",
      test: "lotto/test",
    }),
    total() {
        if (!this.test || !this.test.wins)
            return 0;
        let total = 0; 
        this.test.wins.forEach(w => {
            total += w.odds;
        })
        return total;
    }
  },
  async mounted() {
    await this.getTests();
  },
  methods: {
    ...mapActions({
      getTests: "lotto/get_tests",
      getTest: "lotto/get_test",
    }),
    selectSet(name) {
        this.getTest(name);
    },
    open(t) {
        this.current = t;
    },
    close() {
        this.current = null;
    }
  },
};
</script>

<style lang="less" scoped>
.container {
    color: black;
    font-size: 3vw;
    display: flex;
    flex-flow:column;
    align-items: stretch;
}
.select {
    margin: 1vw;

}
.ticket {
    font-size:3vw;
    width:90%;
    background: #ddd;
    padding: 1vw 4vw;
    margin: 1vw 1vw;
    align-self: stretch;
    display:flex;
    justify-content: space-between;
}
.draw {
    display:flex;
    font-size:4vw;
    margin: 1vw 4vw;
    align-items: center;
}
.date {
    margin-right: 4vw;
}
.numbers {
    display:flex;
}
.number {
    margin: 0 0.5vw;
    background: #ddd;
    border: 1px solid gray;
    border-radius: 50%;
    padding:1vw;
    width:4vw;
    height:4vw;
    line-height: 4vw;
}
.sz {
    border-left:1px solid silver;
}
.wins {
    display: table;
    grid-template-columns: 1fr 1fr 3fr;
    font-size: 4vw;
    gap: 0 4vw;
    justify-items: left;
}
.tn {
    padding: 0 4vw;
    text-align: left;
}
.cn {
    padding: 0 4vw;
    text-align: left;
}
.odds {
    padding: 0 4vw;
    text-align: right;
}
</style>